// extracted by mini-css-extract-plugin
export default {"container":"Search_container__I7kOS","boxForm":"Search_boxForm__hsCuL","boxItem":"Search_boxItem__ua5c6","boxItemBtn":"Search_boxItemBtn__75RSy","boxBtn":"Search_boxBtn__3ZBmD"};